<template>
    <div class="banner bng-casino-banner-new-live-games">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/mobile/new_live_games.jpg' : '/static/banners/casino-home-banner/desktop/new_live_games.jpg'"
        />
        <div class="content">
            <div>{{"components.common.banners.casino-banners.new-live-games.msg1" | translate}}</div>
            <div>{{"components.common.banners.casino-banners.new-live-games.msg2" | translate}}</div>
            <ul>
                <li v-for="item in $t('components.common.banners.casino-banners.new-live-games.msg3')">{{item}}</li>
            </ul>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'video-games' }">{{"components.common.banners.casino-banners.new-live-games.play" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-new-live-games',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/new-live-games.vue